export var zIndex = {
    background: -1,
    foreground: 1,
    menu: 2,
    overlay: 3,
    widget: 4,
    sidebar: 5,
    modal: 6,
    warningScreen: 7,
};
